/**
 * @documental
 * @export Tag
 * @import
 * import { Tag } from "capitalrx-components-2.0/lib/general";
 */

import { FC, ReactNode } from "react";
import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import { TagType } from "./TagType";
import styles from "./styles.module.scss";
import { Tooltip } from "../Tooltip";

/**
 * The `Tag` component properties.
 */
export interface TagProps extends BaseProps {
  /**
   * Indicates the type of the tag. If not specified defaults to `"info"`.
   */
  readonly type?: TagType;

  /**
   * The tag tooltip text.
   */
  readonly tooltip?: ReactNode;

  /**
   * Indicates whether tag colors are inverted.
   */
  readonly inverted?: boolean;

  /** The component children. */
  readonly children?: ReactNode;

  /** The component role. */
  readonly role?: string;
}

/**
 * Displays the child content within a tag of a specified type.
 */
export const Tag: FC<TagProps> = (props) => {
  const { type = "info", inverted = false, tooltip, children, role = "status" } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Tag, "tag", type, { inverted }],
    testIdPrefix: "tag",
  });

  return (
    <Tooltip content={tooltip}>
      {(ref) => (
        <span
          ref={ref}
          {...baseHtmlProps}
          role={role}
        >
          <Body size="mini" inline>
            <Semibold>{children}</Semibold>
          </Body>
        </span>
      )}
    </Tooltip>
  );
};
